import moment from 'moment';

export const getTimeString = (date) => {
  const now = new Date();
  const aDayAgo = new Date();
  aDayAgo.setDate(now.getDate() - 1);
  const aWeekAgo = new Date();
  aWeekAgo.setDate(now.getDate() - 7);
  let formatString = 'MMM D';
  if (date > aDayAgo) {
    formatString = 'HH:mm a';
  } else if (date < aDayAgo && date > aWeekAgo) {
    formatString = 'ddd';
  }
  const timeString = moment(date).format(formatString);
  return timeString;
};

export default { getTimeString };
